export const ColumnTypes = {
  String: 'STRING',
  Text: 'TEXT',
  RichText: 'RICHTEXT',
  Number: 'NUMBER',
  DateOnly: 'DATEONLY',
  Datetime: 'DATETIME',
  Boolean: 'BOOLEAN',
  Reference: 'REFERENCE',
  ArrayOfObject: 'ARRAY_OF_OBJECT',
  File: 'FILE',
  FileUpload: 'FILEUPLOAD',
  HTMLContent: 'HTML_CONTENT',
  Select: 'SELECT',
  MultiSelect: 'MULTISELECT',
} as const

/**
 * Javascriptコードを入力するcolumnの共通props
 */
export const codeInputCommonAttrs = {
  wrapperClass: 'col-12',
  class: 'bg-dark text-white',
  rows: 8,
  style: 'font-family: monospace, monospace; letter-spacing: .05em;'
}

